import { Tuple } from "components/Shared/Interfaces"
import { useIntl } from "react-intl"
import { optionsSelected as optSelected } from "components/Shared/Filters/utils"

const MAX_VALUE = 1
const MAX_STRING_LENGTH = 18
export const EMPTY_STRING = ""

const renderPlaceholder = (
	defaultPlaceholder: string,
	values: Array<Tuple>
) => {
	if (values.length === MAX_VALUE) {
		const text = values[0].name
		return makeTextLimit(text)
	}

	if (values.length > MAX_VALUE) {
		return useIntl().formatMessage({
			id: "phronesis.filters.departments.multiple",
		})
	}

	return defaultPlaceholder
}

const makeTextLimit = (text: string): string => {
	if (text.length > MAX_STRING_LENGTH) {
		return `${text.slice(0, MAX_STRING_LENGTH)}...`
	}
	return text
}

export const getSymetricDifferenceArray = (
	selected: Array<Tuple>,
	options: Array<Tuple>
): Array<Tuple> =>
	selected
		.filter((select) => !options.some((option) => select.code === option.code))
		.concat(
			options.filter(
				(option) => !selected.some((select) => option.code === select.code)
			)
		)

const optionsSelected = (
	selected: Array<Tuple>,
	options: Array<Tuple>,
	allOptions: Array<Tuple>,
	allOption: boolean,
	isMulti: boolean | undefined
): Array<Tuple> =>
	isMulti
		? optSelected(
				getSymetricDifferenceArray(selected, options)[0],
				options,
				allOptions,
				allOption
		  )
		: selected

export { renderPlaceholder, makeTextLimit, optionsSelected }
